<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" sm="5" md="4">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="5" md="4">
              <div class="text-right align-end justify-end d-flex">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="datatableItems"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': $t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_user="{ item }">
            <v-btn @click="$copy(item.id_user)" x-small>
              {{ item.id_user }}
            </v-btn>
          </template>
          <template v-slot:item.transaction_id="{ item }">
            <v-btn @click="$copy(item.transaction_id)" x-small>
              {{ item.transaction_id }}
            </v-btn>
          </template>
          <!-- T -->
          <template
            v-for="(value, index) in valueColors"
            v-slot:[`item.${value}`]="{ item }"
          >
            <span class="caption" :key="index" :class="getColor(item[value])">
              {{ item[value] }}
            </span>
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="showResume">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("deposits") }}</td>
                      <td class="text-right" :class="getColor(resume.deposits)">
                        <b>{{ $t("labelCurrency") }} {{ resume.deposits }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("withdrawals") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume.withdraws)"
                      >
                        <b>{{ $t("labelCurrency") }} {{ resume.withdraws }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td class="text-right" :class="getColor(resume.value)">
                        <b>{{ $t("labelCurrency") }} {{ resume.value }}</b>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "views-backoffice-administrator-accountabilityOnline-bankStatement",
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    breakPoint: "xs",

    deposits: [],
    withdraws: [],
    datatableItems: [],
    listDeposits: [],
    listWithdraws: [],

    valueColors: ["deposit_paid_value", "withdraw_paid_value", "value"],
    showResume: false,
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("idTransaction"),
          value: "transaction_id",
          sortable: false,
        },
        {
          text: this.$t("value"),
          value: "value",
          sortable: true,
        },
        {
          text: this.$t("dateHour"),
          value: "transaction_date",
          sortable: true,
        },
        {
          text: this.$t("operation"),
          value: "name_operation",
        },
        {
          text: this.$t("paymentProvider"),
          value: "provider_name",
        },
        {
          text: this.$t("idUser"),
          value: "id_user",
          sortable: false,
        },
        {
          text: this.$t("user"),
          value: "name_user",
          sortable: false,
        },
      ];
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },

    goTo() {
      return this.$store.state.filters.TabsNavigationButtons.route;
    },
    paymentProvider() {
      return this.$store.state.filters.paymentProvider.value;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getBankStatement();
    },
    goTo(val) {
      this.$router
        .push({
          name: val,
        })
        .catch(() => {});
    },
  },
  methods: {
    reset() {
      this.datatableItems = [];
      this.listDeposits = [];
      this.listWithdraws = [];
      this.resume = {};
      this.showResume = false;
    },

    // Consumo de API Sales Report General Online
    getBankStatement() {
      this.reset();
      const body = {
        ...this.rangeDate,
        payment_provider: this.paymentProvider,
      };
      this.$request
        .post("/administrator/bankOnline/depositsAndWithdraws", body)
        .then((response) => {
          if (!response.dados) return;
          this.datatableItems = response.dados;
          this.datatableItems.forEach((item) => {
            if (
              item.name_operation == "Saque de Crédito Online" ||
              item.name_operation == "Saque de Crédito Instântaneo Online" ||
              item.name_operation == "Validação Bancaria"
            ) {
              item.value = (Number(item.value) * -1).toFixed(2);
              this.listWithdraws.push(Number(item.value) * -1);
            } else {
              item.value = Number(item.value).toFixed(2);
              this.listDeposits.push(Number(item.value));
            }

            item.transaction_date = new Date(
              item.transaction_date.replace(" ", "T")
            ).toLocaleString();
          });
          this.buildResume(this.datatableItems);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Cria o Resumo
    buildResume(datatableItems) {
      if (!datatableItems) return;

      // // CHAVES QUE DEVEM SER SOMADAS
      let resume = {
        withdraws: "",
        deposits: "",
        value: {},
      };
      // SOMANDO OS VALORES DE SAQUES E DEPOSITOS
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      resume.withdraws = Number(
        this.listWithdraws.reduce(reducer) * -1
      ).toFixed(2);
      resume.deposits = Number(this.listDeposits.reduce(reducer)).toFixed(2);
      // console.log(resume);

      // TOTAL DO RESUMO
      resume.value = Number(resume.deposits) + Number(resume.withdraws);
      resume.value = Number(resume.value).toFixed(2);

      this.resume = resume;
      this.showResume = true;
      this.resumeExcelCopy();
    },
    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `<table>
        <tr>${this.resume.deposits.toString().replace(".", ",")}</tr>
        <tr>${this.resume.withdraws.toString().replace(".", ",")}</tr>
        <tr>${this.resume.value.toString().replace(".", ",")}</tr>
     </table>`;
    },

    getColor(value) {
      if (value == 0) return "white--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
